import { render, staticRenderFns } from "./CreateEventOwnPaymentSystem.vue?vue&type=template&id=24cef680&scoped=true"
import script from "./CreateEventOwnPaymentSystem.vue?vue&type=script&lang=ts&setup=true"
export * from "./CreateEventOwnPaymentSystem.vue?vue&type=script&lang=ts&setup=true"
import style0 from "./CreateEventOwnPaymentSystem.vue?vue&type=style&index=0&id=24cef680&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24cef680",
  null
  
)

export default component.exports